import React from "react";
// import "../App.css";
//import { Button } from "layouts/Button";
import Button from "@material-ui/core/Button";
import "./HeroSection.css";
//import video from "assets/video/video-2.mp4";
import imagerice from "assets/img/ftmbg.jpg";
import imagechicken from "assets/img/imagechicken.jpg";
import imagefruit from "assets/img/imagefruit.jpg";
import imagegoat from "assets/img/imagegoat.jpg";
import imagecow from "assets/img/imagecow.jpg";
//import image1 from "assets/img/cover.jpeg";
/* import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container"; */
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
//import Button2 from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "100px",
    paddingBottom: "100px",
    margin: "0px",
  },
  paper: {
    //padding: theme.spacing(8),
    //textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    backgroundColor: "transparent",
    //color: "white",
    marginBottom: "50px",
  },
  card: {
    //maxWidth: "1120px",
    width: "90%",
    //height: "50vh",
    margin: "0 auto",
    padding: theme.spacing(2),
    "&:hover": {
      transform: "scale(1.04)",
      transition: "all 0.3s ease-out",
      //color: "#1c2237",
    },
  },
}));

function HeroSection() {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      id="product"
      /* style={{
        paddingTop: "100px",
        paddingBottom: "100px",
      }} */
    >
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="center"
      >
        <Grid item xs={12} sm={12}>
          <Paper
            className={classes.paper}
            // elevation={3}
            style={{
              backgroundColor: "transparent",
              height: "30vh",
            }}
          >
            <div className="hero-container">
              <h1>FARMER TEAM MANAGEMENT</h1>
              <p>
                We bring all solutions to your farm. By apply all technology we
                have in AI, IoT and Management Skills
              </p>

              {/* <video src={video} autoPlay loop muted /> */}
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <Card className={classes.card}>
              <CardActionArea href="/login">
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  height="280px"
                  image={imagerice}
                  title="Contemplative Reptile"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    FTM for Rice Farming
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    The FTM for Rice Farming is a secure farm management
                    platform, works with farmers, industry and universities with
                    the goal of helping farmers make better management decisions
                    and mitigate risk, maintain and improve yields through the
                    use of machine learning and big data.
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button
                  href="/login"
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  Try it
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <Card className={classes.card}>
              <CardActionArea href="/login">
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  height="280px"
                  image={imagefruit}
                  title="Contemplative Reptile"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    FTM for Fruit Farming
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    The FTM for Fruit Farming is a secure farm management
                    platform, works with farmers, industry and universities with
                    the goal of helping farmers make better management decisions
                    and mitigate risk, maintain and improve yields through the
                    use of machine learning and big data.
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button
                  href="/login"
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  Try it
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <Card className={classes.card}>
              <CardActionArea href="/login">
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  height="280px"
                  image={imagechicken}
                  title="Contemplative Reptile"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    FTM for Poultry Farming
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    The FTM for Poultry Farming is a secure farm management
                    platform, works with farmers, industry and universities with
                    the goal of helping farmers make better management decisions
                    and mitigate risk, maintain and improve yields through the
                    use of machine learning and big data.
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button
                  href="/login"
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  Try it
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <Card className={classes.card}>
              <CardActionArea href="/login">
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  height="280px"
                  image={imagegoat}
                  title="Contemplative Reptile"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    FTM for Goat Farming
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    The FTM for Goat Farming is a secure farm management
                    platform, works with farmers, industry and universities with
                    the goal of helping farmers make better management decisions
                    and mitigate risk, maintain and improve yields through the
                    use of machine learning and big data.
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  href="/login"
                >
                  Try it
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <Card className={classes.card}>
              <CardActionArea href="/login">
                <CardMedia
                  component="img"
                  alt="Contemplative Reptile"
                  height="280px"
                  image={imagecow}
                  title="Contemplative Reptile"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    FTM for Cow Farming
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    The FTM for Cow Farming is a secure farm management
                    platform, works with farmers, industry and universities with
                    the goal of helping farmers make better management decisions
                    and mitigate risk, maintain and improve yields through the
                    use of machine learning and big data.
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  href="/login"
                >
                  Try it
                </Button>
                <Button size="small" color="primary">
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default HeroSection;
